import React, { FC } from "react";
import { CropPeriod } from "@baseTypes/service/dashboard/IWorksDashboardService";
import BaseChartTooltip from "@modules/dashboards/dashboardTooltips/TooltipVariants/BaseChartTooltip/BaseChartTooltip";

export interface WorksTooltipProps {
    cropPeriods?: CropPeriod[]
    children: React.ReactNode
    container?: React.RefObject<HTMLDivElement | null>
}

export const WorksDailyTooltip: FC<WorksTooltipProps> = ({ cropPeriods,
                                                             children,
                                                             container }) => {
    return cropPeriods && cropPeriods.length > 0
        ? <BaseChartTooltip
            flex={false}
            elements={
                cropPeriods.map(period => ({
                    color: period.color,
                    name: period.name,
                    id: `${period.start}-${period.name}-${period.end}`
                }))
            }
            tooltipProps={{
                trigger: 'sticky',
                container: container?.current || undefined,
                targetStyle: { width: 'inherit' }
            }}
            content={children}
            width={180}
            cellsInRow={1}
        />
        : <>{children}</>
}